// import './App.css'
import Home2 from './components/Home2'

function App() {
  return (
    <div className='bg-black text-green-500'>
      {/* <div className='bg-black text-green-500 crt'> */}
      <div className=''>
        <Home2 />
      </div>
    </div>
  )
}

export default App
